import {router} from "@inertiajs/vue3";

export const routeProvider = {
    getDashboard() {
        return route('dashboard')
    },
    getApplication() {
        return route('application');
    },
    getInfo() {
        return route('info');
    },
    getReviews() {
        return route('vocabulary.review');
    },
    getProfile() {
        return route('profile');
    },
    getLeaderboard() {
        return route('leaderboard');
    },
    //courses
    getCourse(courseId) {
        return route('courses.one', { id: courseId })
    },
    getCourseTheme(themeId) {
        return route('theme.theory', { id: themeId })
    },
    //vocab
    getVocabulary() {
        return route('vocabulary');
    },
    getVocabularyDrills() {
        return route('vocabulary.drills');
    },
    getCollections() {
        return route('collections');
    },
    getVocabularyItem(id) {
        return route('vocabulary.item', { id: id })
    },
    getConjugationStart() {
        return route('conjugations.start')
    },
    getConjugationCheck() {
        return route('conjugations.check')
    },
    getConjugationPracticeStart(exerciseId) {
        return route('conjugation-practice.start', { exerciseId })
    },
    getConjugationPracticeComplete(exerciseId, attemptId) {
        return route('conjugation-practice.complete', { exerciseId, attemptId })
    },

    //reviews
    getSimpleReview() {
        return route('vocabulary.review.simple');
    },
    getWriteReview() {
        return route('vocabulary.review.write');
    },
    getReviewTranslation() {
        return route('vocabulary.review.translation');
    },
    getReviewAudition() {
        return route('vocabulary.review.audition');
    },

    //posts
    getAddPost() {
        return route('admin.posts.add');
    },
    getCreatePost() {
        return route('admin.posts.add.post');
    },
    getPostsEdit(id) {
        return route('admin.posts.edit', { id: id });
    },
    getPostSave(id) {
        return route('admin.posts.edit.post', { id: id });
    },

    //exercises
    getAddExercise() {
        return route('admin.exercises.add');
    },
    getCreateExercise() {
        return route('admin.exercises.add.post');
    },
    getExercisesEdit(id) {
        return route('admin.exercises.edit', { id: id });
    },
    getExerciseSave(id) {
        return route('admin.exercises.edit.post', { id: id });
    },
    getExerciseDelete(id) {
        return route('admin.exercises.delete', { id: id });
    },

    getModule(slug, params = {}) {
        return route('modules.one', {slug: slug, ...params})
    },
    getDialogs() {
        return route('dialogs');
    },
    getDialog(id) {
        return route('dialogs.one', { id });
    },

    //gift-certificates
    getCreateGiftCertificate() {
        return route('gift-certificates.create');
    },
    getActivateGiftCertificate() {
        return route('gift-certificates.activate');
    },
    geShowActivateGiftCertificate() {
        return route('gift-certificates.activate.show');
    },
    getGiftCertificatePdf(certificateId) {
        return route('gift-certificates.pdf', { certificateId })
    },

    getAdminUser(userId) {
        return route('admin.users.edit', { userId });
    },

    checkNotifications() {
        return route('notifications.check');
    },
    readNotifications() {
        return route('notifications.read');
    }
}
